import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppIcon from '../components/WhatsAppIcon';

const MainLayout = ({ children }) => {
  return (
    <div>
      <Header />
      <main>{children}</main>
      <Footer />
      <WhatsAppIcon />
    </div>
  );
};

export default MainLayout;
